import { List, flow, pipe } from '@helo/utils'

import type { ConfigSlice } from './configSlice'
import { ConfigSliceParts, ENVIRONMENTS } from './configSlice.parts'

export const loadAppConfig = () =>
  flow(flow.inputExtends<ConfigSlice>(), store =>
    pipe(
      ConfigSliceParts.getAppConfig(),
      ConfigSliceParts.validateAppConfig(),
      appConfig => ({
        ...store,
        config: {
          ...store.config,
          ...appConfig,
        },
      }),
    ),
  )

export const isEnvironment = (environments: ENVIRONMENTS | ENVIRONMENTS[]) =>
  flow(flow.inputExtends<ConfigSlice>(), store =>
    pipe(
      environments,
      ConfigSliceParts.environmentsInputToArray(),
      List.some(env => env === (store.config.ENVIRONMENT as ENVIRONMENTS)),
    ),
  )

export const ConfigSliceActions = {
  loadAppConfig,
  isEnvironment,
}
